import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="h-screen flex flex-col items-center justify-center bg-app-bg px-4">
      <p className="font-serif text-7xl text-app-fg mb-4">404</p>
      <p className="text-base text-app-muted mb-8">Page not found</p>
      <Link
        to="/"
        className="inline-flex items-center justify-center rounded-pill bg-gold text-ink px-6 py-3 text-base font-semibold hover:brightness-105 transition-all"
      >
        Go home
      </Link>
    </div>
  );
}

export default NotFound;
